module.exports = __webpack_public_path__ + "img/subject.6df359d5.png";